import { Circle } from "./elements/Circle";

interface MapCircleProps {
    center: any,
    strokeColor?: string,
    strokeOpacity?: number,
    strokeWeight?: number,
    fillColor?: string,
    fillOpacity?: number,
    radius?: number
}

export const MapCircle = ({
    center,
    strokeColor = "#FF0000",
    strokeOpacity = 1,
    strokeWeight = 1,
    fillColor = "#FF0000",
    fillOpacity = 1,
    radius  = 20
}: MapCircleProps) => {
    return (
        <Circle
            center={center}
            strokeColor={strokeColor}
            strokeOpacity={strokeOpacity}
            strokeWeight={strokeWeight}
            fillColor={fillColor}
            fillOpacity={fillOpacity}
            radius={radius}
        />
    );
}   
